import './workout-setup.css';
import React, {useEffect, useRef, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import Routes from "../../assets/RoutesToPages/Routes";
import {useDispatch} from 'react-redux';
import {createWorkoutSetupData} from '../../store/slices/workoutSetup';
import {ReactComponent as WorkoutContentLogoSetup} from './img-workout-setup/main-img.svg';
import {ReactComponent as WorkoutContentLogoSetupMale} from './img-workout-setup/male-img.svg';
import {ReactComponent as WorkoutContentLogoSetupFemale} from './img-workout-setup/female-img.svg';


const WorkoutSetupPage = () => {
  const difficultyContainerSetupRef = useRef(null);
  const genderContainerSetupRef = useRef(null);
  const musicContainerSetupRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const {dataTitle, title} = location.state || [];
  const localWorkoutSetupData = JSON.parse(localStorage.getItem('workoutSetupData'));
  const [difficultyValue, setDifficultyValue] = useState(
    localWorkoutSetupData ? localWorkoutSetupData.difficulty : 'medium');
  const [characterValue, setCharacterValue] = useState(
    localWorkoutSetupData ? localWorkoutSetupData.character : 'male');
  const [musicValue, setMusicValue] = useState(
    localWorkoutSetupData ? localWorkoutSetupData.music : 'no');
  const dispatch = useDispatch();
  const userProfileData = JSON.parse(localStorage.getItem('userProfileData'));
  const userWorkoutSetupRef = useRef(null);
  const timerFadeIn = useRef(null);


  useEffect(() => {
    if (userWorkoutSetupRef.current) {
      userWorkoutSetupRef.current.classList.add('user-workout-setup-fade-in');
    }

    timerFadeIn.current = setTimeout(() => {
      userWorkoutSetupRef.current.classList.remove('user-workout-setup-fade-in');
    }, 350)

    return () => {
      clearTimeout(timerFadeIn.current)
    }
  }, []);


  const handleChooseItem = (e) => {
    if (e.target.dataset.difficulty) {
      Array.from(difficultyContainerSetupRef.current.children).map(item => {
        item.classList.remove('chosen-setup');
      })
      e.target.classList.add('chosen-setup');
      setDifficultyValue(e.target.dataset.difficulty);
    }
    if (e.target.dataset.gender) {
      Array.from(genderContainerSetupRef.current.children).map(item => {
        item.classList.remove('chosen-setup');
      })
      e.target.classList.add('chosen-setup');
      setCharacterValue(e.target.dataset.gender);
    } else if (e.target.dataset.music) {
      Array.from(musicContainerSetupRef.current.children).map(item => {
        item.classList.remove('chosen-setup');
      })
      e.target.classList.add('chosen-setup');
      setMusicValue(e.target.dataset.music);
    }
  }


  useEffect(() => {
    // if (!userProfileData) {
    //   return;
    // }
    dispatch(createWorkoutSetupData(
      {
        exerciseNameLocal: title,
        exerciseName: dataTitle,
        difficultyLocal: difficultyValue === 'standart' ? 'štandard' :
          difficultyValue === 'medium' ? 'stredný' :
            difficultyValue === 'hard' ? 'ťažký' : 'stredný', // setup for language instead English
        difficulty: difficultyValue,
        character: characterValue,
        music: musicValue
      }
    ))
  }, [difficultyValue, characterValue, musicValue]);


  useEffect(() => {
    if (localWorkoutSetupData) {
      Array.from(difficultyContainerSetupRef.current.children).map(item => {
        if (item.dataset.difficulty === localWorkoutSetupData.difficulty) {
          item.classList.add('chosen-setup');
        }
      });
      Array.from(genderContainerSetupRef.current.children).map(item => {
        if (item.dataset.gender === localWorkoutSetupData.character) {
          item.classList.add('chosen-setup');
        }
      });
      Array.from(musicContainerSetupRef.current.children).map(item => {
        if (item.dataset.music === localWorkoutSetupData.music) {
          item.classList.add('chosen-setup');
        }
      })
    } else {
      Array.from(difficultyContainerSetupRef.current.children).map(item => {
        if (item.dataset.difficulty === 'medium') {
          item.classList.add('chosen-setup');
        }
      });
      Array.from(genderContainerSetupRef.current.children).map(item => {
        if (item.dataset.gender === 'male') {
          item.classList.add('chosen-setup');
        }
      });
      Array.from(musicContainerSetupRef.current.children).map(item => {
        if (item.dataset.music === 'no') {
          item.classList.add('chosen-setup');
        }
      })
    }
  }, []);


  const handleStartExercise = () => {
    navigate(Routes.workoutExercises);
  }


  return (
    <div ref={userWorkoutSetupRef}
         className='workout-container-setup'>
      <p className='workout-container__title-setup'>{title}</p>
      <div className='workout-content-setup'>
        <WorkoutContentLogoSetup className="workout-content-logo-setup"
                                 width='131'
                                 height='134'/>
        <div className='workout-navigation-setup'>
          <img className='workout-navigation__arrow-setup'
               onClick={() => navigate(-1)}
               loading="lazy"
               src={require("./img-workout-setup/back_arrow.svg").default}
               width='24'
               height='24'
               alt="image arrow left">
          </img>
          <img className='workout-navigation__calendar-setup'
               onClick={() => navigate(Routes.calendarPage)}
               loading="lazy"
               src={require("./img-workout-setup/calendar-icon.svg").default}
               width='24'
               height='24'
               alt="icon calendar">
          </img>
        </div>
        <div className='workout-setup-form'>
          <div className='general-difficulty-container'>
            <p className='general-difficulty-title'>Vyberte úroveň obtiažnosti tréningu:</p>
            <div ref={difficultyContainerSetupRef}
                 className='difficulty-container-setup'>
              <div onClick={handleChooseItem}
                   data-difficulty='standart'
                   className='difficulty-setup'>
                štandard
              </div>
              <div onClick={handleChooseItem}
                   data-difficulty='medium'
                   className='difficulty-setup'>
                stredný
              </div>
              <div onClick={handleChooseItem}
                   data-difficulty='hard'
                   className='difficulty-setup'>
                ťažký
              </div>
            </div>
          </div>
          <div className='general-gender-container'>
            <p className='general-gender-title'>Vyberte postavu, ktorá bude vykonávať cvičenia:</p>
            <div ref={genderContainerSetupRef}
                 className='gender-container-setup'>
              <div onClick={handleChooseItem}
                   data-gender='male'
                   className='gender-setup male'>
                <WorkoutContentLogoSetupMale className='male-setup'
                                             width='24'
                                             height='24'/>
              </div>
              <div onClick={handleChooseItem}
                   data-gender='female'
                   className='gender-setup female'>
                <WorkoutContentLogoSetupFemale className='female-setup'
                                               width='24'
                                               height='24'/>
              </div>
            </div>
          </div>
          <div className='general-music-container'>
            <p className='general-music-title'>Chcete cvičiť s hudbou?</p>
            <div ref={musicContainerSetupRef}
                 className='music-container-setup'>
              <div onClick={handleChooseItem}
                   data-music='yes'
                   className='music-setup'>
                áno
              </div>
              <div onClick={handleChooseItem}
                   data-music='no'
                   className='music-setup'>
                nie
              </div>
            </div>
          </div>
          <button className='workout-setup-btn'
                  onClick={handleStartExercise}>
            Ďalej
          </button>
        </div>
      </div>
    </div>
  )
}

export default WorkoutSetupPage;